export const getFormattedCouponDecimalAsPercentage = (values) =>
  values ? `${parseInt(values * 100)}%` : null;
